import type { CustomerDownloadAgreement } from 'types/isomorphic/download.types';

export type BatchAgreement = CustomerDownloadAgreement;

export const PREMIUM_ACCESS_TYPE = 'PremiumAccess';
export const EASY_ACCESS_TYPE = 'EasyAccess';

export interface PremiumAccessAgreementSummary {
  id: number;
  customName?: string;
  isExhausted: boolean;
  authorizedAssetCount: number;
}

// Returned by useBatchAgreements(); kept distinct from BatchAgreementsProps
// so the hook's output and the presentational component's props can evolve
// independently even though they match today.
export interface BatchAgreementsData {
  batchAgreements: BatchAgreement[];
  availablePremiumAccessAgreements?: PremiumAccessAgreementSummary[];
  userHasMultiplePaAgreements: boolean;
  showPaPicker: boolean;
  currentPaAgreementId?: number;
  isSwitchingPremiumAccessAgreement: boolean;
  switchingToPremiumAccessId?: string;
  switchPremiumAccessAgreementError: Error | null;
  onSelectPaAgreement: (nextId: number) => void;
  isSingleAgreement: boolean;
  canEditAgreementSelection: boolean;
  // Mirrors the server's multiPaBulkDownloadActive load option: true whenever
  // it returned an availablePremiumAccessAgreements list at all (even an
  // empty/single-entry one), since that field is only ever present when the
  // flag was on.
  multiPaBulkDownloadActive: boolean;
}

export interface BatchAgreementsProps {
  batchAgreements: BatchAgreement[];
  availablePremiumAccessAgreements?: PremiumAccessAgreementSummary[];
  userHasMultiplePaAgreements: boolean;
  showPaPicker: boolean;
  currentPaAgreementId?: number;
  isSwitchingPremiumAccessAgreement: boolean;
  switchingToPremiumAccessId?: string;
  switchPremiumAccessAgreementError: Error | null;
  onSelectPaAgreement: (nextId: number) => void;
  isSingleAgreement: boolean;
  canEditAgreementSelection: boolean;
  multiPaBulkDownloadActive: boolean;
}
